import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { UserRole } from '../../core/models/user.model';

// Quick-access demo accounts
const DEMO_ACCOUNTS = [
  { email: 'admin',                      label: 'Admin',                          role: 'professional' as UserRole },
  { email: 'elena@fluidarchitects.com',  label: 'Profesional – Dra. Elena Rossi', role: 'professional' as UserRole },
  { email: 'juan@ejemplo.com',           label: 'Cliente – Juan García',          role: 'client'       as UserRole },
  { email: 'maria@ejemplo.com',          label: 'Cliente – María López',          role: 'client'       as UserRole },
];

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  demoAccounts = DEMO_ACCOUNTS;
  form: FormGroup;
  error = '';
  loading = false;

  constructor(
    private auth: AuthService,
    private router: Router,
    private fb: FormBuilder,
  ) {
    this.form = this.fb.group({
      email:    ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  get emailCtrl()    { return this.form.get('email')!; }
  get passwordCtrl() { return this.form.get('password')!; }

  selectDemo(email: string): void {
    const passwords: Record<string, string> = {
      'admin':                      'admin',
      'elena@fluidarchitects.com':  '1234',
      'juan@ejemplo.com':           '1234',
      'maria@ejemplo.com':          '1234',
    };
    this.form.patchValue({ email, password: passwords[email] ?? '' });
    this.error = '';
  }

  submit(): void {
    this.error = '';
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.loading = true;
    const { email, password } = this.form.value;
    setTimeout(() => {
      const ok = this.auth.login(email, password);
      this.loading = false;
      if (!ok) {
        this.error = 'Credenciales incorrectas.';
        return;
      }
      const role = this.auth.currentUser!.role;
      const userId = this.auth.currentUser!.id;
      if (role === 'professional') {
        const doneBefore = localStorage.getItem(`onboarding_done_${userId}`);
        this.router.navigate([doneBefore ? '/professional' : '/onboarding']);
      } else {
        this.router.navigate(['/booking']);
      }
    }, 400);
  }
}
